"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitEventSwipeInfo = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseExitEventSwipeInfo() {
    return {
        exitCoordStartSwipeTapPositionXRelative: undefined,
        exitCoordStartSwipeTapPositionX: undefined,
        exitCoordStartSwipeTapPositionYRelative: undefined,
        exitCoordStartSwipeTapPositionY: undefined,
        exitCoordEndSwipeTapPositionXRelative: undefined,
        exitCoordEndSwipeTapPositionX: undefined,
        exitCoordEndSwipeTapPositionYRelative: undefined,
        exitCoordEndSwipeTapPositionY: undefined,
        exitCoordSwipeTapDuration: undefined,
    };
}
exports.ExitEventSwipeInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exitCoordStartSwipeTapPositionXRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordStartSwipeTapPositionXRelative }, writer.uint32(10).fork()).ldelim();
        }
        if (message.exitCoordStartSwipeTapPositionX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordStartSwipeTapPositionX }, writer.uint32(18).fork()).ldelim();
        }
        if (message.exitCoordStartSwipeTapPositionYRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordStartSwipeTapPositionYRelative }, writer.uint32(26).fork()).ldelim();
        }
        if (message.exitCoordStartSwipeTapPositionY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordStartSwipeTapPositionY }, writer.uint32(34).fork()).ldelim();
        }
        if (message.exitCoordEndSwipeTapPositionXRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordEndSwipeTapPositionXRelative }, writer.uint32(42).fork()).ldelim();
        }
        if (message.exitCoordEndSwipeTapPositionX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordEndSwipeTapPositionX }, writer.uint32(50).fork()).ldelim();
        }
        if (message.exitCoordEndSwipeTapPositionYRelative !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordEndSwipeTapPositionYRelative }, writer.uint32(58).fork()).ldelim();
        }
        if (message.exitCoordEndSwipeTapPositionY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordEndSwipeTapPositionY }, writer.uint32(66).fork()).ldelim();
        }
        if (message.exitCoordSwipeTapDuration !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.exitCoordSwipeTapDuration }, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExitEventSwipeInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exitCoordStartSwipeTapPositionXRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.exitCoordStartSwipeTapPositionX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.exitCoordStartSwipeTapPositionYRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.exitCoordStartSwipeTapPositionY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.exitCoordEndSwipeTapPositionXRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.exitCoordEndSwipeTapPositionX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.exitCoordEndSwipeTapPositionYRelative = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.exitCoordEndSwipeTapPositionY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.exitCoordSwipeTapDuration = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseExitEventSwipeInfo();
        message.exitCoordStartSwipeTapPositionXRelative =
            object.exitCoordStartSwipeTapPositionXRelative ?? undefined;
        message.exitCoordStartSwipeTapPositionX =
            object.exitCoordStartSwipeTapPositionX ?? undefined;
        message.exitCoordStartSwipeTapPositionYRelative =
            object.exitCoordStartSwipeTapPositionYRelative ?? undefined;
        message.exitCoordStartSwipeTapPositionY =
            object.exitCoordStartSwipeTapPositionY ?? undefined;
        message.exitCoordEndSwipeTapPositionXRelative =
            object.exitCoordEndSwipeTapPositionXRelative ?? undefined;
        message.exitCoordEndSwipeTapPositionX =
            object.exitCoordEndSwipeTapPositionX ?? undefined;
        message.exitCoordEndSwipeTapPositionYRelative =
            object.exitCoordEndSwipeTapPositionYRelative ?? undefined;
        message.exitCoordEndSwipeTapPositionY =
            object.exitCoordEndSwipeTapPositionY ?? undefined;
        message.exitCoordSwipeTapDuration =
            object.exitCoordSwipeTapDuration ?? undefined;
        return message;
    },
};
//# sourceMappingURL=exit_event_swipe_info.js.map